export const productOptions = [
  { id: 'aibackgroundremover', name: 'AI Background Remover' },
  { id: 'hireflow', name: 'Hireflow' },
  { id: 'paystubgen', name: 'Paystub Instant' },
  { id: 'smartdoctools', name: 'SmartDocTools' },
  { id: 'avellojewelry', name: 'Avello Jewelry' },
  { id: 'wakeupalarmsaas', name: 'WakeUpAlarmSaaS' }
];

export async function api(path, options = {}) {
  const response = await fetch(path, {
    credentials: 'include',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {})
    }
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || 'Request failed.');
  }
  return data;
}

export async function submitForm(path, payload) {
  return api(path, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function getCookie(name) {
  return document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${name}=`))
    ?.split('=')
    .slice(1)
    .join('=');
}
